export class InternationalPod {
    public id: number | null;
    public international_shipment_id: number | null;
    public consignor_company_code: string ;
    public perm_shipment_id: string ;
    public shipment_status: string ;
    public document_path: string ;
    public document_name: string ;
    public todo_date: Date|null;
    public createdAt: Date|null;

    constructor(data: InternationalPodData | void) {
        if (data === undefined) {
            this.id = null;
            this.international_shipment_id = null;
            this.consignor_company_code = "";
            this.perm_shipment_id = "";
            this.shipment_status = "";
            this.document_path = "";
            this.document_name = "";
            this.todo_date = null;
            this.createdAt = null;
        } else {
            this.id = data.id;
            this.international_shipment_id = data.international_shipment_id;
            this.consignor_company_code = data.consignor_company_code;
            this.perm_shipment_id = data.perm_shipment_id;
            this.shipment_status = data.shipment_status;
            this.document_path = data.document_path;
            this.document_name = data.document_name;
            this.todo_date = data.todo_date;
            this.createdAt = data.createdAt;
        }
    }
}

export type InternationalPodData = {
     id: number | null;
     international_shipment_id: number | null;
     consignor_company_code: string ;
     perm_shipment_id: string ;
     shipment_status: string ;
     document_path: string ;
     document_name: string ;
     todo_date: Date|null;
     createdAt: Date|null;
}